export default function List() {
	return {
		MuiList: {
			styleOverrides: {
				root: {
					backgroundColor: 'transparent !important',
				},
			},
		},
	}
}
